'use strict';
module.exports = require('./MultiSelect.vue');


//////////////////
// WEBPACK FOOTER
// ./~/primevue/multiselect/index.js
// module id = 470
// module chunks = 0